import FinanciableVehicles from '../../../../components/financiable-vehicles-label/financiable-vehicles-label.desktop';
import financiableVehiclesLabel from './financiable-vehicles-label';

export default financiableVehiclesLabel(FinanciableVehicles);
